"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePollingMode = void 0;
const react_1 = require("react");
const gamepadEvents_1 = require("../../core/gamepadEvents");
const PollingModeManager_1 = require("../../core/managers/PollingModeManager");
/**
 * @returns the current polling mode (All, Navigation, Callbacks, None)
 */
const usePollingMode = () => {
    const [pollingMode, setPollingMode] = (0, react_1.useState)(PollingModeManager_1.PollingModeManager.getPollingMode());
    (0, react_1.useEffect)(() => {
        gamepadEvents_1.GamepadEventEmitter.addListener(gamepadEvents_1.PollingModeEvent.Change, setPollingMode);
        return () => {
            gamepadEvents_1.GamepadEventEmitter.removeListener(gamepadEvents_1.PollingModeEvent.Change, setPollingMode);
        };
    }, []);
    return pollingMode;
};
exports.usePollingMode = usePollingMode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUG9sbGluZ01vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvdXRpbGl0eS91c2VQb2xsaW5nTW9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsNERBQTREOzs7QUFFNUQsaUNBQTRDO0FBQzVDLDREQUFpRjtBQUVqRiwrRUFBNEU7QUFFNUU7O0dBRUc7QUFDSSxNQUFNLGNBQWMsR0FBRyxHQUFnQixFQUFFO0lBQzVDLE1BQU0sQ0FBQyxXQUFXLEVBQUUsY0FBYyxDQUFDLEdBQUcsSUFBQSxnQkFBUSxFQUFDLHVDQUFrQixDQUFDLGNBQWMsRUFBRSxDQUFDLENBQUM7SUFFcEYsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNYLG1DQUFtQixDQUFDLFdBQVcsQ0FBQyxnQ0FBZ0IsQ0FBQyxNQUFNLEVBQUUsY0FBYyxDQUFDLENBQUM7UUFFekUsT0FBTyxHQUFHLEVBQUU7WUFDUixtQ0FBbUIsQ0FBQyxjQUFjLENBQUMsZ0NBQWdCLENBQUMsTUFBTSxFQUFFLGNBQWMsQ0FBQyxDQUFDO1FBQ2hGLENBQUMsQ0FBQztJQUNOLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUVQLE9BQU8sV0FBVyxDQUFDO0FBQ3ZCLENBQUMsQ0FBQztBQVpXLFFBQUEsY0FBYyxrQkFZekIifQ==